module.exports = __webpack_public_path__ + "img/Support-skill-318.909f380b.png";